var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"text-center"},[_c('v-overlay',{attrs:{"value":_vm.spinnerState}},[_c('v-main',[_c('h1',[_vm._v("Loading......")]),_c('br'),_c('v-progress-circular',{attrs:{"indeterminate":"","size":"64"}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }